import {SidebarProvider} from "@/components/ui/sidebar";

import {useIsMobile} from "../hooks";
import {DESKTOP_APP_HEADER_HEIGHT} from "../lib/desktop-app-header";
import {PanicTriggerButton} from "@/src/modules/panic-alerts/components/panic-trigger-button";

import DesktopHeader from "./desktop-header";

export function AuthenticatedAppShell({children}: {children: React.ReactNode}) {
  const isMobile = useIsMobile();

  return (
    <div
      className="flex h-svh min-h-0 w-full flex-col"
      style={{"--app-desktop-header-height": DESKTOP_APP_HEADER_HEIGHT} as React.CSSProperties}
    >
      <SidebarProvider className="flex min-h-0 w-full flex-1 flex-col !h-auto">
        {!isMobile ? <DesktopHeader /> : null}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">{children}</div>
        <PanicTriggerButton />
      </SidebarProvider>
    </div>
  );
}
